import type { ShowSasCallbacks } from 'matrix-js-sdk/src/crypto-api';
import { useEffect } from 'react';

import logger from 'utils/logging/faro';

import { VerificationErrorEnum } from '../../utils';

type UseSasDecimalNumbersParams = {
  sasCallbacks: ShowSasCallbacks | null;
  sasDecimalNumbers: string | null;
  setSasDecimalNumbers: (value: string | null) => void;
  setErrorKey: (value: VerificationErrorEnum | null) => void;
};

const useSasDecimalNumbers = ({
  sasCallbacks,
  sasDecimalNumbers,
  setSasDecimalNumbers,
  setErrorKey,
}: UseSasDecimalNumbersParams) => {
  useEffect(() => {
    if (!sasCallbacks || !sasCallbacks.sas?.decimal) {
      setSasDecimalNumbers(null);
      return;
    }

    const decimal = sasCallbacks.sas.decimal;
    if (!Array.isArray(decimal) || decimal.length !== 3) {
      setErrorKey(VerificationErrorEnum.FAILED_RETRY);
      return logger.error('Invalid SAS decimal callback', sasCallbacks.sas);
    }

    const decimalsString = decimal.join('-');
    if (sasDecimalNumbers === decimalsString) return;

    setSasDecimalNumbers(decimalsString);
    setErrorKey(null);
  }, [sasCallbacks, sasDecimalNumbers, setSasDecimalNumbers, setErrorKey]);
};

export default useSasDecimalNumbers;
